module.exports = __webpack_public_path__ + "static/img/lg-ess-img-02-02@t.2cc941d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/lg-ess-img-02-02@t.jpg
// module id = fC6X
// module chunks = 0